import React, { Component } from "react";
import { Link } from "react-router-dom";
import Table from "./../common/table";

class erInstructionTable extends Component {
  
  componentDidUpdate() {
    const headerCheckbox = document.querySelector('th input[type="checkbox"]');
    if (headerCheckbox && this.props.erInstructions.length > 0) {
      const checkedCount = this.props.erInstructions.filter(wi => 
        this.props.checkedFields.includes(wi._id)
      ).length;
      
      if (checkedCount === 0) {
        headerCheckbox.indeterminate = false;
        headerCheckbox.checked = false;
      } else if (checkedCount === this.props.erInstructions.length) {
        headerCheckbox.indeterminate = false;
        headerCheckbox.checked = true;
      } else {
        headerCheckbox.indeterminate = true;
        headerCheckbox.checked = false;
      }
    }
  }

  columns = [
    {
      key: "checkbox",
      label: (
        <input
          type="checkbox"
          style={checkboxStyles}
          onChange={this.props.toggle}
          ref={checkbox => {
            if (checkbox && this.props.erInstructions.length > 0) {
              const checkedCount = this.props.erInstructions.filter(wi => 
                this.props.checkedFields.includes(wi._id)
              ).length;
              
              if (checkedCount === 0) {
                checkbox.indeterminate = false;
                checkbox.checked = false;
              } else if (checkedCount === this.props.erInstructions.length) {
                checkbox.indeterminate = false;
                checkbox.checked = true;
              } else {
                checkbox.indeterminate = true;
                checkbox.checked = false;
              }
            }
          }}
        />
      ),
      content: (listerInstruction) => (
        <span className="icon-img sm-r-5" style={{ marginTop: "15px" }}>
          <input
            type="checkbox"
            style={checkboxStyles}
            onChange={this.props.handleCheckboxChange}
            value={listerInstruction._id}
            checked={this.props.checkedFields.includes(listerInstruction._id)}
          />
        </span>
      ),
    },
    {
      label: "Owner",
      path: "user",
      content: (erinstruction) => (
        <span className="icon-img sm-r-5">
          {erinstruction?.user?.imageSrc && (
            <img
              style={{ width: "20px", height: "20px", borderRadius: "50%", marginRight: "4px" }}
              src={erinstruction?.user?.imageSrc}
              alt="User Avatar"
            />
          )}
          {erinstruction?.user?.contactName?.first} {erinstruction?.user?.contactName?.last}
        </span>
      ),
    },

    { label: "Name", path: "name" },
    { 
      label: "Description", 
      path: "description",
      content: (erinstruction) => erinstruction?.description || 'No description'
    },
    { 
      label: "FieldType", 
      path: "fieldType",
      content: (erinstruction) => {
        if (erinstruction?.fieldType) { 
          return erinstruction.fieldType;
        } else if (erinstruction?.fieldType === '') {
          return 'Empty';
        } else {
          return 'Backend Missing';
        }
      }
    },
    { 
      label: "Category", 
      path: "category",
      content: (erinstruction) => erinstruction?.category || 'N/A'
    },	
    { 
      label: "ServiceType", 
      path: "serviceType",
      content: (erinstruction) => {
        if (erinstruction?.serviceType) {
          return erinstruction.serviceType;
        } else if (erinstruction?.serviceType === '') {
          return 'Empty';
        } else {
          return 'Backend Missing';
        }
      }
    },		
    { label: "Tags", path: "tags" },
    { label: "Version", path: "version" },
    {
      label: "Business Name",
      path: "businessNo",
      content: (erinstruction) => {
        const businessLogo = erinstruction?.companyinfo?.companies?.imageSrc || 
                           erinstruction?.companyinfo?.imageSrc || 
                           erinstruction?.businessNo?.companyInfo?.businessLogo || 
                           erinstruction?.businessNo?.businessLogo || 
                           erinstruction?.businessNo?.logo || 
                           erinstruction?.businessNo?.companyInfo?.logo ||
                           erinstruction?.businessNo?.image ||
                           erinstruction?.businessNo?.companyInfo?.image;
        
        return (
          <span className="icon-img sm-r-5">
            {businessLogo ? (
              <img
                style={{ width: "20px", height: "20px", borderRadius: "50%", marginRight: "4px" }}
                src={businessLogo}
                alt="Business Logo"
                onError={(e) => {}}
              />
            ) : (
              <div
                style={{ 
                  width: "20px", 
                  height: "20px", 
                  borderRadius: "50%", 
                  backgroundColor: "#28a745",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "4px",
                  fontSize: "10px",
                  color: "white"
                }}
              >
                <i className="fa fa-building"></i>
              </div>
            )}
            {erinstruction?.businessNo?.companyInfo?.businessName || 
             erinstruction?.businessNo?.name || 
             'No Business'}
          </span>
        );
      },
    },
    {
      label: "Actions", 
      path: "actions",
      content: (erinstruction) => {
        if (!erinstruction.actions || !Array.isArray(erinstruction.actions)) {
          return "No actions";
        }
        
        if (erinstruction.actions.length > 0 && typeof erinstruction.actions[0] === 'object') {
          return erinstruction.actions.map((action, index) => (
            <span key={action._id || index}>
              {action?.name || 'Unnamed Action'}
              {index !== erinstruction.actions.length - 1 ? ", " : ""}
            </span>
          ));
        }
        
        return `${erinstruction.actions.length} action(s)`;
      }
    },
    { label: "VideoLink", path: "internalVideoLink" },
    { label: "Reference", path: "reference" },
    { label: "Language", path: "language" },
    { label: "Note", path: "note" },
    {
      label: "Created On",
      path: "createdOn",
      content: (erinstruction) => {
        if (!erinstruction.createdOn) {
          return <span>N/A</span>;
        }
        try {
          const date = new Date(erinstruction.createdOn);
          if (isNaN(date.getTime())) {
            return <span>Invalid Date</span>;
          }
          const formattedDate = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          });
          const formattedTime = date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
          });
          return (
            <div style={{ whiteSpace: 'nowrap', fontSize: '12px' }}>
              <div style={{ fontWeight: '500' }}>{formattedDate}</div>
              <div style={{ color: '#6c757d', fontSize: '11px' }}>{formattedTime}</div>
            </div>
          );
        } catch (error) {
          return <span>Error</span>;
        }
      },
    },   
    {
      label: "Edited On",
      path: "editedOn",
      content: (erinstruction) => {
        if (!erinstruction.editedOn) {
          return <span>N/A</span>;
        }
        
        try {
          const date = new Date(erinstruction.editedOn);
          if (isNaN(date.getTime())) {
            return <span>Invalid Date</span>;
          }
          
          const formattedDate = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          });
          
          const formattedTime = date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
          });
          
          return (
            <span>
              {formattedDate}<br />
              {formattedTime}
            </span>
          );
        } catch (error) {
          return <span>Error</span>;
        }
      },
      
    },              
  ];
  
  render() {
    const { erInstructions, onSort, sortColumn } = this.props;
    return (
      <Table
        columns={this.columns}
        sortColumn={sortColumn}
        onSort={onSort}
        data={erInstructions}
      />
    );
  }
}

const checkboxStyles = {
  width: "15px",
  height: "15px",
  marginTop: "0.4rem",
  borderRadius: 0,
};

const actionAssigneeStyles = {
  fontSize: "11px",
  color: "#6c757d",
  fontStyle: "italic"
};

export default erInstructionTable;

